import { Component, inject } from '@angular/core';
import { CDN_URL } from '@maximizer/core/shared/domain';
import { TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { environment } from '../../../environments/environment';
import { BookDemoDirective } from '../../directives/book-demo.directive';
import { LANGUAGE } from '../../language';

@Component({
  selector: 'maximizer-showcase-ai-hub-fse-plus-page',
  standalone: true,
  imports: [KENDO_BUTTON, TranslatePipe, BookDemoDirective],
  templateUrl: './ai-hub-fse-plus.page.html',
  styleUrls: ['./ai-hub-fse-plus.page.scss'],
})
export class AiHubFsePlusPage {
  private readonly language = inject(LANGUAGE);
  readonly cdn = inject(CDN_URL);
  readonly learnMoreUrl = this.language.startsWith('fr')
    ? environment.aiCrmUrlFr
    : environment.aiCrmUrl;
}
